import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { ViewOfferButton } from './ViewOfferButton'

interface Props {
  isFlash?: boolean
  roomOccupancy?: string
  taxDetails?: {
    taxesAndFeesAmount: number
    taxesPayableAtProperty: boolean
  }
  priceDetails: App.Pricing
  className?: string
  offerId: string
  variant?: 'default' | 'condensed'
}

function CruisePriceDetails(props: Props) {
  const intl = useIntl()
  const { variant = 'default', priceDetails, isFlash, taxDetails, roomOccupancy, offerId } = props

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <VerticalSpacer gap={8}>
        <div>
          <PriceRowPriceCaption>{intl.formatMessage({
            id: 'U066vyS-v-9t51qBNa66',
            defaultMessage: 'From',
            description: 'Price caption label preceding the cruise price in the cruises section',
          })}
          </PriceRowPriceCaption>
          <PriceRowPrice
            size="L"
            price={priceDetails.price}
            saleUnit={priceDetails.saleUnit}
          />
          {!isFlash && <PriceRowTaxesAndFees />}
          {!!priceDetails.value && <PriceRowValueDiscountWithCaption
            size="M"
            originalValue={priceDetails.value}
            discountPercentage={priceDetails.discountPercent}
          />}
          {isFlash && !!roomOccupancy && <PriceRowCaption>{roomOccupancy}</PriceRowCaption>}
          {isFlash && !!taxDetails && variant === 'default' && <PriceRowTaxesAndFees />}
        </div>
        <PriceRowAgentHubCommission
          productType={isFlash ? 'cruise-flash' : 'cruise'}
          offerId={offerId}
        />
      </VerticalSpacer>
      <ViewOfferButton variant={variant} />
    </Group>
  )
}

export default CruisePriceDetails
